module.exports = __webpack_public_path__ + "assets/img/9f5098f76430afd12e75434e99afccad.png";